<mat-toolbar class="dialog-header">
  <span><mat-icon>filter_alt</mat-icon> Data Filters</span>
  <button mat-stroked-button color="primary" mat-dialog-close>
    <mat-icon>close</mat-icon>
    <mat-label>Close</mat-label>
  </button>
</mat-toolbar>

<mat-dialog-content>

  <mat-card class="filter-section-card">

    <mat-card-header>
      <mat-card-subtitle>Data-Scope Filters</mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
      <div class="filter-grid">
        @for (key of keys; track key) {
          @if (!filters.hidden()[key]) {
            <mat-form-field class="filter-field" appearance="outline" subscriptSizing="dynamic">
              <mat-label>{{ filters.catalog().labels[key] }}</mat-label>
              <mat-select
                multiple
                [value]="draft()[key]"
                [disabled]="locked()[key]"
                (selectionChange)="selectFromPanel(key, $event.value)">
                <mat-select-trigger>{{ triggerText()[key] }}</mat-select-trigger>

                <mat-option>
                  <ngx-mat-select-search
                    [ngModel]="query()[key]"
                    (ngModelChange)="onSearch(key, $event)"
                    [placeholderLabel]="'Search ' + filters.catalog().labels[key].toLowerCase()"
                    [preventHomeEndKeyPropagation]="true" />
                </mat-option>

                @for (option of visibleOptions()[key]; track option.value) {
                  <mat-option [ngClass]="inactiveOption(option)" [value]="option.value">

                    <span class="option-label">{{ option.label }}</span>
                    @if (option.detail) {
                      <span class="option-detail">{{ option.detail }}</span>
                    }

                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
        }
      </div>
    </mat-card-content>

  </mat-card>

</mat-dialog-content>

<mat-toolbar class="dialog-footer">
  <button mat-raised-button [disabled]="actionsDisabled()" (click)="clear()">Clear</button>
  <button mat-flat-button color="primary" [disabled]="actionsDisabled()" (click)="apply()">
    <mat-icon>filter_alt</mat-icon>
    Apply
  </button>
</mat-toolbar>
